import type { GlobalApiAccountAccess } from '@data/account-access';
import type { GlobalApiPaymentDetails } from '@data/global-api-payments';

export const getFlow = (
  subject: GlobalApiAccountAccess | GlobalApiPaymentDetails
) => {
  if ('paymentInitiationFlow' in subject) {
    return subject.paymentInitiationFlow;
  }

  if ('accountAccessFlow' in subject) {
    return subject.accountAccessFlow;
  }

  throw new Error('Invalid subject');
};
